<template>
  <div>
    <b-card-body>
      <b-card class="loadContainer">
        <b-form submit.stop.prevent="loadSelectedScenario">
          <b-row v-if="loaded">
            <b-col sm="12">
              <div class="tableTxt">
                <div>
                  <span class=""><b>{{$t('deleteScenarioFilter')}}</b></span>
                  <b-input class="mt-1 input-pentagro" :placeholder="$t('placeholderDeleteScenarioFilter')" v-model="filter" />
                </div>
              </div>
              <br />
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <div v-if="this.scenarioList.length == 0">
                {{$t('scenarioListMessage')}}<br />
              </div>
              <div v-else>
                <div class="row">
                  <div
                    class="
                      col-12
                      table-responsive-md table-wrapper-scroll-y
                      my-custom-scrollbar
                    "
                  >
                    <table class="table table-hover table-sm">
                      <thead class="thead-dark">
                        <th scope="col">{{$t('savedScenariosHeader')}}</th>
                      </thead>
                      <tbody class="">
                        <template>
                          <tr v-for="(scenario, i ) in this.filteredScenario" :key="scenario.id">
                            <td
                              v-if="scenario.name != 'PADRAO'"
                              :id="'scneario-' + i"
                              @click="selectedScenario(scenario.name)"
                              class="text-truncate tableTxt"
                              style="max-width: 100px"
                            >
                              {{ scenario.name }}
                            </td>
                          </tr>
                          <h6 class="mt-4" v-if="this.filteredScenario.length == 1">
                            {{$t('semDadosCenario')}}
                          </h6>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-if="loaded" class="rowDistance">
                <div class="text-truncate tableTxt" style="max-width: 370px">
                  <b>{{$t('selectedScenarioDeleteScenario') + ' '}}</b>{{ this.selection }}
                </div>
              </div>
              <b-row v-else class="waitTxt rowDistance"
                >{{$t('waitingaDataBaseDeleteScenario')}}</b-row
              >
              <br />
            </b-col>
          </b-row>

          <b-row class="groupBtn">
            <div>
              <img
                v-if="!this.scenarioList.length == 0"
                src="@/assets/excluir.png"
                style="margin-left: 30px"
                :title="$t('deleteScenarioButtom')"
                alt="Excluir cenário"
                @click="$bvModal.show('confirmDeleteScenarioForm')"
              />
              <img
                v-if="!this.scenarioList.length == 0"
                src="@/assets/apagar.png"
                style="margin-left: 30px"
                :title="$t('clear')"
                alt="limpar"
                @click="reset"
              />
              <img
                id="closeModalPassword"
                class="float-right"
                src="@/assets/sair.png"
                style="margin-left: 20px"
                :title="$t('exit')"
                alt="Sair"
                @click="$bvModal.hide('modalDeleteScenario')"
              />
            </div>
          </b-row>
        </b-form>
      </b-card>
      <b-modal
      id="confirmDeleteScenarioForm"
      :title="$t('atention')"
      centered
      ok-variant="danger"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="deleteSelectedScenario"
      ><center>{{$t('deleteScenarioConfirmMessage')}}</center></b-modal
    >
    </b-card-body>
  </div>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "DeleteScenario",
  data: function () {
    return {
      selection: "",
      scenarioList: [],
      loaded: false,
      filter: "",
      filteredScenario: [],
    };
  },
  watch: {
    filter() {
      this.filteredScenario = this.scenarioList.filter((scenario) => {
        const scenarioName = scenario.name.toUpperCase();
        const filter = this.filter.toUpperCase();
        if (scenarioName.includes(filter)) return scenario;
      });
    },
  },
  methods: {
    async loadScenariosList() {
      const url = `${urlMainAPI}/getsavedsimulationscenario`;
      await axios
        .get(url)
        .then((res) => {
          this.scenarioList = res.data.sort((a, b) =>
            a.name > b.name
              ? 1
              : a.name === b.name
              ? a.id > b.id
                ? 1
                : -1
              : -1
          );
          this.filteredScenario = this.scenarioList;
          this.loaded = true;
        })
        .catch();
    },
    deleteSelectedScenario() {
      if (this.selection.length == 0) {
        showError(this.$t('favorSelecionarUmcenario'))
        return;
      }  
      let obj = {};
      obj.name = this.selection;
      const encodedName = encodeURIComponent(obj.name).replace(/'/g, "%27");
      console.log(encodedName);
      const url = `${urlMainAPI}/deletesimulationscenario/${encodedName}`;
      axios.get(url).then((res) => {
        this.selection = "";
        if (res.data === "Cenário excluído com sucesso!")
          defaultSuccess(res.data);
        else showError(res.data);
        this.loadScenariosList();
      });
    },
    selectedScenario(name) {
      this.selection = name;
    },
    reset() {
      this.selection = "";
    },
  },
  created() {
    this.loadScenariosList();
  },
};
</script>

<style scoped>
.loadContainer {
  max-width: 600px;
}

.my-xstom-scrollbar {
  position: relative;
  height: 180px;
  text-overflow: ellipsis;
  overflow-x: hidden;
}

.table-wrapper-scroll-y {
  display: block;
}

.txtSelection {
  max-width: 400px;
  text-overflow: ellipsis;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.tableTxt {
  font-size: 0.8em;
}

.tableTxt:hover {
  cursor: pointer;
}

.waitTxt {
  display: flex;
  justify-content: center;
  background: black;
  color: white;
  margin-bottom: 10px;
}

.rowDistance {
  margin-top: 20px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img {
  max-height: 35px;
}

table {
  border-collapse: initial;
  border-spacing: initial;
}
</style>
